<template>
  <img
    v-if="url"
    :src="url"
    :width="size"
    :height="size"
    :alt="alt"
    class="pin-preview"
  >
  <span
    v-else
    class="pin-preview pin-preview--empty"
    :style="{ width: `${size}px`, height: `${size}px` }"
  />
</template>

<script>
import { pinMarkerUrl } from '../utils/pinMarker'

export default {
  name: 'PinPreview',

  props: {
    // { color, icon_class } — o mesmo formato que a API manda em `*_pin_style`
    pinStyle: { type: Object, default: null },
    size: { type: Number, default: 48 },
    alt: { type: String, default: '' },
  },

  computed: {
    url() {
      return pinMarkerUrl(this.pinStyle)
    },
  },
}
</script>

<style scoped>
.pin-preview {
  display: inline-block;
  vertical-align: middle;
}

.pin-preview--empty {
  border: 1px dashed #d8d6de;
  border-radius: 8px;
}
</style>
